import React, { useState, useEffect } from 'react'
import { Table, Panel, Icon, Input, InputGroup } from 'rsuite'
import { budgetFormat, numberThousandSeparator } from '../../../utils/formatterUtil'

export default function BudgetTableView({ schema, ...props }) {
  const { Column, HeaderCell, Cell } = Table
  const [dataList, setDataList] = useState([])
  const [isResizable, setIsResizable] = useState(false)

  const [sortColumn, setSortColumn] = useState()
  const [sortType, setSortType] = useState()
  const [loading, setLoading] = useState(false)

  const [inputSearchValue, setInputSearchValue] = useState('')
  const [inputSearchPlaceholder, setInputSearchPlaceholder] = useState('')

  useEffect(() => {
    switch (schema.categoryType) {
      case 1:
        setInputSearchPlaceholder('ค้นหากิจกรรม/ค่าดำเนินโครงการ/รายละเอียดค่าใช้จ่าย')
        break

      case 2:
        setInputSearchPlaceholder('ค้นหาค่าบริหารโครงการ/รายละเอียดค่าใช้จ่าย')
        break

      case 3:
        setInputSearchPlaceholder('ค้นหาครุภัณฑ์โครงการ/รายละเอียดค่าใช้จ่าย')
        break

      default:
        break
    }
  }, [schema])

  useEffect(() => {
    if (schema.categoryType) {
      schema.categoryType < 4 && setIsResizable(true)
    }
    if (schema.values) {
      let dataArr = [...schema.values]

      if (dataArr.length > 0) {
        let sumPrice = 0
        dataArr.forEach((item) => {
          sumPrice += parseFloat(item.sumPrice)
        })

        let summarryObj = {
          stongText: 'จำนวนเงินรวม',
          sumPrice: sumPrice,
        }

        dataArr.push(summarryObj)
      }

      setDataList(dataArr)
    }

    setInputSearchValue('')
  }, [schema])

  const getData = () => {
    if (sortColumn && sortType) {
      return dataList?.sort((a, b) => {
        let x = a[sortColumn]
        let y = b[sortColumn]
        if (typeof x === 'string') {
          x = x.charCodeAt()
        }
        if (typeof y === 'string') {
          y = y.charCodeAt()
        }
        if (sortType === 'asc') {
          return x - y
        } else {
          return y - x
        }
      })
    }
    return dataList
  }

  const handleSortColumn = (sortColumn, sortType) => {
    setLoading(true)
    setTimeout(() => {
      setLoading(false)
      setSortColumn(sortColumn)
      setSortType(sortType)
    }, 500)
  }

  const handleSearchDataTable = (type) => {
    let result = []
    let dataArr = [...schema.values]
    let summarryObj = {}
    if (dataArr.length > 0) {
      let sumPrice = 0
      dataArr.forEach((item) => {
        sumPrice += parseFloat(item.sumPrice)
      })

      summarryObj = {
        stongText: 'จำนวนเงินรวม',
        sumPrice: sumPrice,
      }

      // dataArr.push(summarryObj)
    }

    console.log('summarryObj ', summarryObj)

    if (inputSearchValue) {
      schema?.values?.map((item) => {
        switch (type) {
          case 1:
            if (
              item.activityName.match(inputSearchValue) ||
              item.costName.match(inputSearchValue) ||
              item.costDetail.match(inputSearchValue)
            ) {
              result.push(item)
            }
            break

          case 2:
            if (
              item.costName.match(inputSearchValue) ||
              item.subCostName.match(inputSearchValue) ||
              item.costDetail.match(inputSearchValue)
            ) {
              result.push(item)
            }
            break

          case 3:
            if (
              item.costName.match(inputSearchValue) ||
              item.costDetail.match(inputSearchValue) ||
              item.costDate.match(inputSearchValue)
            ) {
              result.push(item)
            }
            break

          default:
            break
        }
      })
      result.push(summarryObj)
      setDataList(result)
    } else {
      let dataArr = [...schema.values]
      dataArr.push(summarryObj)
      setDataList(dataArr)
    }
  }

  const handleChangeVal = (val) => {
    setInputSearchValue(val)
  }

  return (
    <Panel eventKey={2} bodyFill>
      {schema.categoryType && schema.categoryType < 4 && (
        <>
          <div style={{ marginBottom: 10 }}>
            <InputGroup inside style={{ width: '100%' }}>
              <Input
                value={inputSearchValue}
                style={{ borderColor: '#2da888' }}
                onChange={handleChangeVal}
                placeholder={inputSearchPlaceholder}
              />
              <InputGroup.Button
                style={{ backgroundColor: '#2da888', color: '#ffffff' }}
                onClick={() => {
                  handleSearchDataTable(schema?.categoryType)
                }}
              >
                <Icon icon="search" />
              </InputGroup.Button>
            </InputGroup>
          </div>
          {/* <div style={{ textAlign: '-webkit-right' }}>
            <InputGroup inside style={{ width: 300, marginBottom: 10 }}>
              <Input
                value={inputSearchValue}
                style={{ borderColor: '#2da888' }}
                onChange={handleChangeVal}
                placeholder={inputSearchPlaceholder}
              />
              <InputGroup.Button
                style={{ backgroundColor: '#2da888', color: '#ffffff' }}
                onClick={() => {
                  handleSearchDataTable(schema?.categoryType)
                }}
              >
                <Icon icon="search" />
              </InputGroup.Button>
            </InputGroup>
          </div> */}
        </>
      )}

      <div>
        <Table
          rowKey="id"
          height={dataList?.length >= 10 && schema.categoryType == 1 ? 800 : 400}
          autoHeight={dataList?.length <= 5}
          wordWrap={true}
          //data={dataList}
          data={getData()}
          sortColumn={sortColumn}
          sortType={sortType}
          onSortColumn={handleSortColumn}
          loading={loading}
        >
          <Column width={80} align="center">
            <HeaderCell>ลำดับ</HeaderCell>
            <Cell>
              {(rowData, index) => {
                // console.log('rowDatarowDatarowData ', rowData)
                if (dataList.length - 1 > index) {
                  return index + 1
                }
              }}
            </Cell>
          </Column>

          {schema.activityOption && (
            <Column sortable width={250} resizable={isResizable}>
              <HeaderCell>กิจกรรม</HeaderCell>
              <Cell dataKey={'activityName'} />
            </Column>
          )}

          {schema.costName && (
            <Column sortable width={250} resizable={isResizable}>
              <HeaderCell>{schema.costName.label}</HeaderCell>
              {/* <Cell dataKey={schema.costName.name} /> */}
              <Cell dataKey="costName">
                {(rowData) => {
                  let str = ''
                  if (rowData.costName === 'ค่าบริหารจัดการสำนักงาน') {
                    str = `${rowData.costName} - ${rowData.subCostName}`
                  } else {
                    str = rowData.costName
                  }
                  return str
                }}
              </Cell>
            </Column>
          )}

          {schema.costDetail && (
            <Column
              sortable
              minWidth={270}
              // width={schema.categoryType == 4 ? 700 : 300}
              width={300}
              resizable={isResizable}
            >
              <HeaderCell>{schema.costDetail.label}</HeaderCell>
              <Cell dataKey={schema.costDetail.name} />
            </Column>
          )}

          {schema.costTime && (
            <Column width={180} align="center" resizable={isResizable}>
              <HeaderCell>วันที่เริ่มใช้ครุภัณฑ์</HeaderCell>
              {/* <Cell dataKey={schema.costName.name} /> */}
              <Cell dataKey="costDate" />
            </Column>
          )}

          {schema.costPerUnit && (
            <Column width={150} align="right" resizable={isResizable}>
              <HeaderCell>{schema.costPerUnit.label}</HeaderCell>
              <Cell>
                {(rowData) => {
                  return budgetFormat(rowData.costPerUnit)
                }}
              </Cell>
            </Column>
          )}

          {schema.costPerVat && (
            <Column width={140} align="right" resizable={isResizable}>
              <HeaderCell>{schema.costPerVat.label}</HeaderCell>
              {/* <Cell dataKey={schema.costPerVat.name}></Cell> */}
              <Cell dataKey={schema.costPerVat.name}>
                {(rowData) => {
                  return numberThousandSeparator(rowData[schema.costPerVat.name])
                }}
              </Cell>
            </Column>
          )}

          {schema.unitOfMeasure && (
            <Column width={schema.unitOfMeasure ? 180 : 130} resizable={isResizable}>
              <HeaderCell>
                {schema.quantity.label +
                  (schema.unitOfMeasure ? '/' + schema.unitOfMeasure.label : '')}
              </HeaderCell>
              <Cell>
                {(rowData) => {
                  return rowData.stongText ? (
                    <span>
                      <b>{rowData.stongText}</b>
                    </span>
                  ) : (
                    <span>
                      {(numberThousandSeparator(rowData.quantity) || '') +
                        (rowData.unitOfMeasure ? '/' + rowData.unitOfMeasure : '')}
                    </span>
                  )
                }}
              </Cell>
            </Column>
          )}

          {schema.quantity && schema.categoryType == 4 && (
            <Column width={140} align="right" resizable={isResizable}>
              <HeaderCell>จำนวน</HeaderCell>
              <Cell dataKey={'quantity'}>
                {(rowData) => {
                  return budgetFormat(rowData.quantity)
                }}
              </Cell>
            </Column>
          )}

          <Column width={180} align="right" resizable={isResizable}>
            <HeaderCell>จำนวนเงิน (บาท)</HeaderCell>
            <Cell>
              {(rowData) => {
                return rowData.stongText ? (
                  <span>
                    <b>{budgetFormat(rowData.sumPrice)}</b>
                  </span>
                ) : (
                  budgetFormat(rowData.sumPrice)
                )
              }}
            </Cell>
          </Column>
        </Table>
      </div>
    </Panel>
  )
}
